import React, { useEffect, useRef } from "react";
import RelatorioCalibracaoPrensaPrint from "../CalibracaoPrensa/RelatorioCalibracaoPrensaPrint";
import {
  calcularBlocos,
  calcularBlocosAbsorcao,
  calcularIdadeDias,
  calcularResumo,
  formatarDataBR,
  numeroBR,
} from "./tijoloSoloCimentoCalculos";
import "./RelatorioRupturaTijoloSoloCimento.css";
import LogoRelatorio from "../Components/LogoRelatorio/LogoRelatorio";
import useNomeArquivoPdf from "../Utils/useNomeArquivoPdf";

function imprimirEmRetrato() {
  const styleId = "relatorio-tijolo-solo-cimento-print-orientacao";
  document.getElementById(styleId)?.remove();

  const style = document.createElement("style");
  style.id = styleId;
  style.media = "print";
  style.textContent = `
    @page relatorioTijoloSoloCimento {
      size: A4 portrait;
      margin: 0;
    }
  `;
  document.head.appendChild(style);
  window.print();
}

function valor(valorCampo, fallback = "-") {
  return valorCampo || fallback;
}

function valorTabela(valorCampo, casas = 1, fallback = "-") {
  const formatado = numeroBR(valorCampo, casas);
  return formatado || fallback;
}

function diferencaNominal(nominal, valorCampo) {
  const numero = Number(String(valorCampo || "").replace(",", "."));
  if (!Number.isFinite(numero) || numero <= 0) return "";
  return nominal - numero;
}

function obterDimensoesNominais(dimensoesDeclaradas) {
  const numeros = String(dimensoesDeclaradas || "")
    .match(/\d+(?:[,.]\d+)?/g)
    ?.map((item) => Number(item.replace(",", ".")))
    .filter((item) => Number.isFinite(item));

  if (numeros?.length >= 3) {
    return {
      largura: numeros[0],
      altura: numeros[1],
      comprimento: numeros[2],
    };
  }

  return { largura: 90, comprimento: 240, altura: 140 };
}

function dividir(lista, quantidade) {
  const grupos = [];
  for (let i = 0; i < lista.length; i += quantidade) {
    grupos.push(lista.slice(i, i + quantidade));
  }
  return grupos;
}

function Cabecalho({ ensaio, dataRelatorio }) {
  return (
    <>
      <table className="cabecalho-bloco">
        <tbody>
          <tr>
            <td rowSpan="3" className="logo-cell">
              <LogoRelatorio alt="Logo" className="logo"  />
            </td>
            <td rowSpan="3" className="titulo-principal">
              SISTEMA DE GESTÃO DA QUALIDADE
              <br />
              Relatório de ensaio - Tijolo Solo Cimento - resistência à compressão e da absorção de água.
            </td>
            <td>RQ 2.3.6</td>
          </tr>
          <tr>
            <td>REVISÃO 00</td>
          </tr>
          <tr>
            <td>08/04/2026</td>
          </tr>
        </tbody>
      </table>
      <div className="linha-info">
        <span>
          <strong>DATA</strong>   {formatarDataBR(dataRelatorio)}
        </span>
        <span>
          <strong>CÓDIGO:</strong> {valor(ensaio?.codigo, "RE-SC-000/2026")}
        </span>
      </div>
    </>
  );
}

function LinhaFinal() {
  return (
    <div className="rodape-restrito">
      <div className="linha-final" aria-hidden="true" />
      <div className="texto-rodape-restrito">
        DOCUMENTO PARA USO RESTRITO. REPRODUÇÃO/CÓPIA PROIBIDA SEM AUTORIZAÇÃO DA EMPRESA
      </div>
    </div>
  );
}

function RelatorioFotografico({ ensaio, fotos = [] }) {
  if (!fotos.length) return null;

  const FOTOS_POR_PAGINA = 6;

  return dividir(fotos, FOTOS_POR_PAGINA).map((paginaFotos, paginaIndex) => (
    <div
      className="pagina pagina-fotografica pagina-solo-cimento"
      key={`fotos-${paginaIndex}`}
    >
      <Cabecalho ensaio={ensaio} dataRelatorio={ensaio?.dataRelatorio} />
      <div className="dados-cliente dados-cliente-solo-cimento">
        <div><strong>CLIENTE:</strong> {valor(ensaio?.cliente)}</div>
        <div><strong>ENDEREÇO:</strong> {valor(ensaio?.endereco)}</div>
      </div>
      <div className="secao">RELATÓRIO FOTOGRÁFICO</div>
      <div className="grade-fotos">
        {dividir(paginaFotos, 2).map((linha, linhaIndex) => (
          <div className="linha-fotos-bloco" key={`linha-${paginaIndex}-${linhaIndex}`}>
            <div className="linha-fotos">
              {linha.map((foto, index) => {
                const numeroFoto = paginaIndex * FOTOS_POR_PAGINA + linhaIndex * 2 + index + 1;
                return (
                  <div className="foto-item" key={foto.id || foto.url || numeroFoto}>
                    <div className="foto-imagem">
                      <img src={foto.url} alt={foto.legenda || `Foto ${numeroFoto}`} />
                    </div>
                    <div className="foto-legenda">
                      {foto.legenda || `FOTO ${String(numeroFoto).padStart(2, "0")}`}
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="linha-azul-fotos" />
          </div>
        ))}
      </div>
      <LinhaFinal />
    </div>
  ));
}

function RelatorioSoloCimento({ ensaio, blocos, blocosAbsorcao, resumo, fotosRelatorio, onVoltar }) {
  const dataFabricacao = ensaio.dataFabricacaoNaoInformada
    ? "Não informado"
    : formatarDataBR(ensaio.dataFabricacao);
  const idadeCalculada = ensaio.dataFabricacaoNaoInformada
    ? "-"
    : calcularIdadeDias(ensaio.dataFabricacao, ensaio.dataEnsaio) || "-";

  return (
    <div className="relatorio-tijolo-solo-cimento-print relatorio-solo-cimento-print">
      {onVoltar && (
        <div className="acoes-print">
          <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
          <button className="btn-imprimir" onClick={imprimirEmRetrato}>Imprimir</button>
        </div>
      )}

      <div className="pagina pagina-solo-cimento">
        <Cabecalho ensaio={ensaio} dataRelatorio={ensaio.dataRelatorio} />

        <div className="dados-cliente dados-cliente-solo-cimento">
          <div><strong>CLIENTE:</strong> {valor(ensaio.cliente)}</div>
          <div><strong>ENDEREÇO:</strong> {valor(ensaio.endereco)}</div>
        </div>

        <div className="secao">1. OBJETIVO DO ENSAIO</div>
        <div className="texto">
          Análise dimensional, determinação da resistência à compressão e da absorção de água em tijolos de solo cimento.
        </div>

        <div className="secao">2. IDENTIFICAÇÃO DA AMOSTRA</div>
        <table className="tabela-info">
          <tbody>
            <tr><td>Procedência:</td><td>{valor(ensaio.procedencia || ensaio.cliente)}</td></tr>
            <tr><td>Tijolo:</td><td>{valor(ensaio.blocoDescricao)}</td></tr>
            <tr><td>Lote:</td><td>{valor(ensaio.lote)}</td></tr>
            <tr><td>Dimensões (Comp x Larg x Alt) mm:</td><td>{valor(ensaio.dimensoesDeclaradas)}</td></tr>
            <tr><td>Resistência esperada:</td><td>{valor(ensaio.resistenciaEsperada)}</td></tr>
          </tbody>
        </table>

        <div className="secao">3. LOCAL DA APLICAÇÃO</div>
        <div className="texto">{valor(ensaio.localAplicacao || ensaio.obra)}</div>

        <div className="secao">4. METODOLOGIA</div>
        <div className="texto metodologia-solo-cimento">
          Os ensaios seguiram as prescrições das normas da ABNT:<br />
          NBR 8491:2013 - Tijolo de solo-cimento — Requisitos;<br />
          NBR 8492:2013 - Tijolo de solo-cimento — Análise dimensional, determinação da resistência à compressão e da absorção de água — Método de ensaio;<br />
          NBR 6136:2016 - Blocos vazados de concreto simples para alvenaria - Requisitos.
        </div>

        <div className="secao">5. DADOS DOS ENSAIOS</div>
        <div className="subsecao">5.1. Ensaio de compressão e análise dimensional</div>
        <div className="texto texto-dados-solo-cimento">
          Foram ensaiados à compressão axial: <strong>{String(blocos.length).padStart(2, "0")}</strong> tijolos solo cimento.
          <span> recebimento: <strong>{formatarDataBR(ensaio.dataRecebimento)}</strong></span><br />
          Os blocos foram capeados com pasta de cimento nas faces de aplicação de carga.<br />
          Data de fabricação: <strong>{dataFabricacao}</strong> &nbsp;&nbsp;
          Data do ensaio: <strong>{formatarDataBR(ensaio.dataEnsaio)}</strong> &nbsp;&nbsp;
          Idade declarada: <strong>{idadeCalculada}</strong>
        </div>

        <div className="quadro-titulo">Quadro 1 - Resultados de Resistência à Compressão Axial e análise dimensional</div>
        <table className="tabela-resultados tabela-planilha quadro-solo-cimento">
          <thead>
            <tr>
              <th rowSpan="3">BLOCO<br />Nº</th>
              <th rowSpan="3">Massa<br />(g)</th>
              <th colSpan="9">DIMENSÕES (mm)</th>
              <th colSpan="2">RUPTURA</th>
            </tr>
            <tr>
              <th colSpan="2">Largura (L)</th>
              <th colSpan="2">Comprim. (C)</th>
              <th colSpan="2">Altura (H)</th>
              <th colSpan="3">Média</th>
              <th rowSpan="2">Área<br />(mm²)</th>
              <th rowSpan="2">Tensão<br />(MPa)</th>
            </tr>
            <tr>
              <th>1ª Det.</th><th>2ª Det.</th>
              <th>1ª Det.</th><th>2ª Det.</th>
              <th>1ª Det.</th><th>2ª Det.</th>
              <th>L</th><th>C</th><th>H</th>
            </tr>
          </thead>
          <tbody>
            {blocos.map((item, index) => (
              <tr key={index}>
                <td>{item.bloco || String(index + 1).padStart(2, "0")}</td>
                <td>{valorTabela(item.massa, 1)}</td>
                <td>{valorTabela(item.largura1, 1)}</td><td>{valorTabela(item.largura2, 1)}</td>
                <td>{valorTabela(item.comprimento1, 1)}</td><td>{valorTabela(item.comprimento2, 1)}</td>
                <td>{valorTabela(item.altura1, 1)}</td><td>{valorTabela(item.altura2, 1)}</td>
                <td>{valorTabela(item.larguraMedia, 1)}</td>
                <td>{valorTabela(item.comprimentoMedia, 1)}</td>
                <td>{valorTabela(item.alturaMedia, 1)}</td>
                <td>{valorTabela(item.area, 0)}</td>
                <td><strong>{valorTabela(item.tensaoRupturaMpa, 2)}</strong></td>
              </tr>
            ))}
            <tr className="linha-resumo-solo-cimento">
              <td colSpan="10" rowSpan="2"></td>
              <td colSpan="2">Valor mínimo</td>
              <td><strong>{valorTabela(resumo.resistenciaMinima, 1)}</strong></td>
            </tr>
            <tr className="linha-resumo-solo-cimento">
              <td colSpan="2">Resistência média</td>
              <td><strong>{valorTabela(resumo.resistenciaMedia, 1)}</strong></td>
            </tr>
          </tbody>
        </table>

        <div className="subsecao">5.2. Ensaio de absorção de água</div>
        <div className="quadro-titulo">Quadro 3 - Resultados ensaio de Absorção</div>
        <table className="tabela-resultados tabela-absorcao-solo-cimento">
          <thead>
            <tr>
              <th>BLOCO</th><th>Seco na estufa</th><th>Massa úmida (Mu)</th><th>Absorção (%)</th>
              <th>IMAGEM REPRESENTATIVA DO ENSAIO</th>
            </tr>
          </thead>
          <tbody>
            {blocosAbsorcao.map((item, index) => (
              <tr key={index}>
                <td>{item.bloco || String(index + 1).padStart(2, "0")}</td>
                <td>{valorTabela(item.massaSeca, 1)}</td>
                <td>{valorTabela(item.massaUmida, 1)}</td>
                <td>{valorTabela(item.absorcao, 1)}</td>
                {index === 0 && (
                  <td rowSpan={Math.max(blocosAbsorcao.length, 1) + 1} className="celula-fotos-absorcao">
                    <div className="fotos-absorcao fotos-absorcao-solo-cimento">
                      {[0, 1, 2].map((fotoIndex) => {
                        const foto = ensaio.absorcaoFotos?.[fotoIndex];
                        return foto?.url
                          ? <img key={fotoIndex} src={foto.url} alt={foto.legenda || `Absorção ${fotoIndex + 1}`} />
                          : <div key={fotoIndex} className="foto-absorcao-vazia" />;
                      })}
                    </div>
                  </td>
                )}
              </tr>
            ))}
            <tr className="linha-absorcao-media">
              <td colSpan="3">Absorção média (%)</td>
              <td><strong>{valorTabela(resumo.absorcaoMedia, 1)}</strong></td>
            </tr>
          </tbody>
        </table>
        <LinhaFinal />
      </div>
      <RelatorioFotografico ensaio={ensaio} fotos={fotosRelatorio} />
      {ensaio.prensaRuptura && (
        <div className="certificado-prensa-anexo">
          <RelatorioCalibracaoPrensaPrint dados={ensaio.prensaRuptura} />
        </div>
      )}
    </div>
  );
}


export default function RelatorioRupturaTijoloSoloCimento({
  ensaio,
  fotosRelatorio = [],
  onVoltar,
  autoPrint = false,
}) {
  const jaImprimiuRef = useRef(false);
  useNomeArquivoPdf(ensaio?.codigo);

  const opcoesCalculo = { dividirComprimentoArea: true };
  const blocos = calcularBlocos(ensaio?.blocos || [], opcoesCalculo);
  const blocosAbsorcao = calcularBlocosAbsorcao(ensaio?.blocosAbsorcao || []);
  const resumo = calcularResumo(blocos, blocosAbsorcao, opcoesCalculo);

  useEffect(() => {
    if (!autoPrint || jaImprimiuRef.current) return;

    jaImprimiuRef.current = true;
    const frame = window.requestAnimationFrame(imprimirEmRetrato);
    return () => window.cancelAnimationFrame(frame);
  }, [autoPrint]);

  if (!ensaio) return null;

  return (
    <RelatorioSoloCimento
      ensaio={ensaio}
      blocos={blocos}
      blocosAbsorcao={blocosAbsorcao}
      resumo={resumo}
      fotosRelatorio={fotosRelatorio}
      onVoltar={onVoltar}
    />
  );
}
